import { vars } from '@croquiscom-pvt/zds/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

const icon_holder_styles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
`;

export const Wrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
  color: #495057;
  border-radius: 8px;
  background-color: ${vars.v3Color.gray50};
`;

export const Link = styled.a`
  padding: 10px 8px;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
`;

export const InfoIcon = styled.span`
  ${icon_holder_styles};
  margin-right: 2px;
`;

export const ArrowIcon = styled.span`
  ${icon_holder_styles};
  margin-left: auto;
`;
